import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d7b811c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DialogPlaceHolder" }
const _hoisted_2 = {
  class: "D-Flex W-100 Events-None",
  style: {"min-height":"100vh","position":"relative","z-index":"3500"}
}
const _hoisted_3 = { class: "DialogBase" }
const _hoisted_4 = { class: "W-100 F1_5em F-Bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer W-100" }, null, -1))
const _hoisted_6 = {
  class: "W-100 D-Flex",
  style: {"flex-direction":"column"}
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 0,
  class: "F-CR F_75em",
  style: {"text-align":"start","margin":"0 1em"}
}
const _hoisted_9 = {
  class: "W-100 D-Flex P-Rel",
  style: {"flex-direction":"column"}
}
const _hoisted_10 = ["placeholder", "type"]
const _hoisted_11 = {
  key: 0,
  class: "F-CR F_75em",
  style: {"text-align":"start","margin":"0 1em"}
}
const _hoisted_12 = { class: "P-Abs Inset0 D-Flex Events-None" }
const _hoisted_13 = { class: "W-100 D-Flex F_75em" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_15 = { class: "W-100 D-Flex F1em" }
const _hoisted_16 = { class: "W-100 D-Flex" }
const _hoisted_17 = {
  key: 0,
  style: {"min-height":"1em"},
  class: "M-Auto F-CR"
}
const _hoisted_18 = { class: "W-100 D-Flex F1em" }
const _hoisted_19 = { class: "W-100 D-Flex" }
const _hoisted_20 = {
  style: {"min-height":"1em"},
  class: "M-Auto F-CR"
}
const _hoisted_21 = {
  style: {"margin-top":"30px"},
  class: "W-100 D-Flex F1em"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "DialogShade",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.CloseMe && _ctx.CloseMe(...args)))
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            onKeypress: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.SignIN && _ctx.SignIN(...args)), ["enter"])),
            class: "W-100 H-100 color3 F1_25em"
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.Translate('Sign In', 'تسجيل الدخول')), 1),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass([{'ErrorBorder' : ((_ctx.Email.replace(/nbsp;/g, '').trim() === '' || !_ctx.Email) || (_ctx.UserNameServerErrors !== '')) && _ctx.ErrorsVisibilty}, "CookiesInput color2"]),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Email) = $event)),
                placeholder: _ctx.LanguageSelector('Email', 'البريد الالكتروني')
              }, null, 10, _hoisted_7), [
                [_vModelText, _ctx.Email]
              ]),
              (_ctx.UserNameServerErrors !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.UserNameServerErrors), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass([{'ErrorBorder' : ((_ctx.Password.replace(/nbsp;/g, '').trim() === '' || !_ctx.Password) || (_ctx.PassServerErrors !== ''))  && _ctx.ErrorsVisibilty}, "CookiesInput color2"]),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.Password) = $event)),
                placeholder: _ctx.LanguageSelector('Password', 'كلمة السر'),
                type: _ctx.ShowPass ? 'text': 'password'
              }, null, 10, _hoisted_10), [
                [_vModelDynamic, _ctx.Password]
              ]),
              (_ctx.PassServerErrors !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.PassServerErrors), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_CookiesIcon, {
                  class: "M-Auto SQR2em Pointer O-25 ShowPassClass",
                  style: _normalizeStyle([_ctx.ShowPass ? 'opacity : 0.5' : '', {"pointer-events":"all","margin-inline-end":"1.5em"}]),
                  Color: _ctx.ShowPass ? { ColorA:  _ctx.Theme.UserColors.fourth } : {},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ShowPass = !_ctx.ShowPass)),
                  ID: ('Show' as IconsIDs)
                }, null, 8, ["style", "Color"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_CookiesCheckBox, {
                style: {"margin-left":"1em","margin-top":"1em"},
                Res: "SignInRememberMe",
                Name: _ctx.LanguageSelector('Remember Me', 'تذكرني')
              }, null, 8, ["Name"])
            ]),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (_ctx.ErrorsVisibilty)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.DialogErrors[0]), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.ServerError), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.SignIN && _ctx.SignIN(...args))),
                class: "M-Auto F1em",
                style: _normalizeStyle([{"color":"black"}, {background: _ctx.Theme.UserColors.third}])
              }, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.LanguageSelector('Sign In', 'تسجيل دخول')), 1)
              ], 4)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}